import React, { useEffect } from "react";
import '../calendar.css';
import { useTranslation } from "react-i18next";


const Table = ({
    title,
    cols = [],
    raws,
    nbCols = cols.length,
    lastRaw,
    firstRaw,

    rawTemplate,
    colTemplate,
    titleTemplate,

    style,
    twStyle,
    border = 'border border-slate-100 divide-x divide-gray-300',
    globalTW = 'shadow-md border border-slate-300',

    shown = true
}) => {
    const { t } = useTranslation();

    style = { ...style, gridTemplateColumns: `repeat(${nbCols}, minmax(0, 1fr))` };
    twStyle = ' ' + twStyle;
    border = ' ' + border;
    globalTW = ' ' + globalTW;


    if (!rawTemplate) {
        rawTemplate = (raw, index) => {
            return <>
                {raw.map((element, index) => (
                    <p className="text-sm text-left pl-2 font-medium text-gray-500" key={index + element}> {element} </p>
                ))}
            </>
        }
    }

    if (!colTemplate) {
        colTemplate = (col, index) => {
            return <div key={index}>
                <p className="text-xl text-center font-medium text-gray-500" key={index + col}> {col} </p>
            </div>
        }
    }

    if (!titleTemplate) {
        titleTemplate = (title, index) => {
            return <div key={index} style={{ gridTemplateColumns: `repeat(${nbCols}, minmax(0, 1fr))` }} className="border border-slate-300">
                <p className="text-xl text-center font-medium text-gray-500"> {t(title)} </p>
            </div>
        }
    }

    if (!shown) return;

    return (
        ((nbCols > 0 || firstRaw || lastRaw || raws.length > 0)) ? (
            <div className={"mx-2 my-4 h-fit relative" + globalTW}>
                <div className="w-max min-w-full overflow-x-auto overflow-y-clip">
                    {(title) && (
                        <div className={"grid" + border}  >
                            {titleTemplate(title)}
                        </div>
                    )}

                    {(firstRaw) && <div> {firstRaw} </div>}

                    <div className={"grid" + twStyle + border} style={style} >
                        {cols.map((col, index) => {
                            return colTemplate(col, index)
                        })}
                    </div>

                    {raws.map((raw, index) => (
                        <div
                            className={`grid` + twStyle + border}
                            style={{ ...style }}
                            key={index}
                        >
                            {rawTemplate(raw, index)}
                        </div>
                    ))}

                    {(lastRaw) && <div> {lastRaw} </div>}

                </div>
            </div>
        ) : (<div></div>)
    );
}

export default Table;